// ウィジェットの枠（AgentFrame）に付ける印。Esc、操作がないときに入口へ戻す処理、伸縮のつまみが、枠の要素を探すのに使う
export const AGENT_FRAME_SELECTOR = '[data-agent-frame]'

export const isInsideAgentFrame = (target: EventTarget | null): boolean =>
  target instanceof Element && target.closest(AGENT_FRAME_SELECTOR) !== null
